import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UtilService {

  private permissionValues = new BehaviorSubject(null);

  public spanishRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length == 0 || pageSize == 0) { return `0 de ${length}`; }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
    return `${startIndex + 1} - ${endIndex} de ${length}`;
  }

  public paginatorIntl = {
    itemsPerPageLabel: "Registros por página:",
    getRangeLabel: this.spanishRangeLabel
  }

  public pagesReferences =
    {
      Home: 1,
      Benefits: 7,
      Income: 0,
      IncomeInvestment: 2,
      IncomeMax: 6,
      IncomeLifeTime: 4,
      AboutUs: 5,
      OurSupport: 3,
      VirtualAgency: 8,
      Blog: 9,
      Agency: 10
    };

  public itemDetail: any;

  constructor(
    public sanitizer: DomSanitizer
  ) { }

  public getPermission() {
    return this.permissionValues.asObservable();
  }

  public setPermission(value: any) {
    this.permissionValues.next(value);
  }

  // string | ArrayBuffer
  public getSanitizer(urlImagen: any) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(urlImagen);
  }

  public getDateString(date, isSingle: boolean) {
    if (isSingle)
      return date.substring(8, 10) + ' de ' + this.getMonth(Number.parseInt(date.substring(5, 7))) + ' de ' + date.substring(0, 4);
    else
      return date.substring(3, 5) + ' de ' + this.getMonth(Number.parseInt(date.substring(0, 2))) + ' de ' + date.substring(6, 10);
    // return date.substring(8,10) + ' de ' + this.getMonth(Number.parseInt(date.substring(5,7))) + ' de ' + date.substring(0,4);
  }

  public getPadNumber(num: number, size: number): string {
    let s = num + "";
    while (s.length < size) s = "0" + s;
    return s;
  }

  public getMonth(month: number) {
    var month_ = '';
    switch (month) {
      case 1: month_ = 'Enero'; break;
      case 2: month_ = 'Febrero'; break;
      case 3: month_ = 'Marzo'; break;
      case 4: month_ = 'Abril'; break;
      case 5: month_ = 'Mayo'; break;
      case 6: month_ = 'Junio'; break;
      case 7: month_ = 'Julio'; break;
      case 8: month_ = 'Agosto'; break;
      case 9: month_ = 'Septiembre'; break;
      case 10: month_ = 'Octubre'; break;
      case 11: month_ = 'Noviembre'; break;
      case 12: month_ = 'Diciembre'; break;
      default: break;
    }
    return month_;
  }

  // #region [Tool Img to Base64]
  async transformValidB64(img) {
    return new Promise(async (resolve, reject) => {
      if (img.includes('http')) {
        if (img.includes('/assets/')) {
          img = img.replace('//assets', "/assets");
          img = img.replace(img.split('/assets/')[0], '');
          img = img.replace('/benefits/', "/benefits_portal/");
        }
        await this.getBase64ImageFromUrl(img).then(result => {
          img = result;
          resolve(img);
        }).catch(err => console.error(err));
      } else {
        img = 'data:image/jpeg;base64,' + img;
        resolve(img);
      }
    })
  }

  async getBase64ImageFromUrl(imageUrl) {
    var res = await fetch(imageUrl);
    var blob = await res.blob();

    return new Promise((resolve, reject) => {
      var reader = new FileReader();
      reader.addEventListener("load", function () {
        resolve(reader.result);
      }, false);

      reader.onerror = () => {
        return reject(this);
      };
      reader.readAsDataURL(blob);
    })
  }
  // #endregion

  replaceSpecialText(text: any) {
    return text ? text
      .replaceAll('&nbsp;', ' ')
      .replaceAll('<p>', '')
      .replaceAll('</p>', '')
      .replaceAll('&lt;p&gt;', '')
      .replaceAll('&lt;/p&gt', '')
      .replaceAll('<br>', '') : '';
  }

  getMessageDiscount(discountText: string) {
    if (discountText.includes('%')) { return 'descuento en'; }
    else if (discountText.toLowerCase().includes('s/')) { return 'precio especial'; }
    else if (discountText.toLowerCase().includes('factor')) { return ''; }
  }

  getMessageDiscountAmount_01(discountMount: string, discountText: string) {
    if (discountMount.includes('%')) { return discountMount; }
    else if (discountMount.toLowerCase().includes('s/')) { return discountMount; }
    else if (discountMount.toLowerCase().includes('factor')) { return ''; }
  }
  getMessageDiscountAmount_02(discountMount: string, discountText: string) {
    if (discountMount.includes('%')) { return ''; }
    else if (discountMount.toLowerCase().includes('s/')) { return ''; }
    else if (discountMount.toLowerCase().includes('factor')) { return String().concat('descuento en ', discountText); }
  }

  getMessageDiscountText_01(discountMount: string) {
    if (discountMount.includes('%')) { return 'descuento en'; }
    else if (discountMount.toLowerCase().includes('s/')) { return 'precio especial'; }
    else if (discountMount.toLowerCase().includes('factor')) { return ''; }
  }
  getMessageDiscountText_02(discountMount: string, discountText: string) {
    if (discountMount.includes('%')) { return discountText; }
    else if (discountMount.toLowerCase().includes('s/')) { return discountText; }
    else if (discountMount.toLowerCase().includes('factor')) { return ''; }
  }
  getMessageDiscountText_03(discountMount: string) {
    if (discountMount.includes('%')) { return ''; }
    else if (discountMount.toLowerCase().includes('s/')) { return ''; }
    else if (discountMount.toLowerCase().includes('factor')) { return discountMount; }
  }
}
